import {AppState} from '@app/context/context';

export interface ClientSelectionErrorEvent {
    isError: boolean;
}

export function emitClientSelectionError(
    setState: React.Dispatch<React.SetStateAction<AppState>>,
    event: ClientSelectionErrorEvent
) {
    setState((prevState) => ({
        ...prevState,
        isClientSelectionError: (event as ClientSelectionErrorEvent).isError
    }));
}
